import * as React from 'react';

import { kebabCase } from 'lodash';
import { TrackedLink } from '@origin-digital/ods-core';

import { CardLinkContainer, ContentContainer, Content, Stack, Title } from './CardLink.styles';
import { DangerousHtml } from '../DangerousHtml';
import { FixedAspectImage } from './FixedAspectImage';
import { getCloudinaryUrl } from '../../services/cloudinary';
import { Heading4 } from '../Text';
import { ICard } from '../../../src/models/content.interfaces';

export const CardLink = (props: ICard) => {
  const { logoSHA, headline, bylineHtml, buttonLabel, href, newTab, imageSHA } = props;
  const dataIdPrefix = 'product-card';

  return (
    <CardLinkContainer data-id="card-link-item">
      <TrackedLink
        trackingType="CustomLink"
        trackingLabel={kebabCase(headline)}
        href={href}
        target={newTab ? '_blank' : '_self'}
        data-id={`${dataIdPrefix}-${kebabCase(headline)}`}
      >
        <FixedAspectImage imageSHA={imageSHA} alt={`${headline} - image`} />
        <ContentContainer>
          <Content>
            {!!logoSHA && <img src={getCloudinaryUrl(logoSHA)} alt={`${headline} logo`} />}
            <Stack>
              <Title>
                <DangerousHtml html={headline} />
              </Title>
              <Heading4>
                <DangerousHtml html={bylineHtml} />
              </Heading4>
              <Heading4 data-id="link">{buttonLabel}</Heading4>
            </Stack>
          </Content>
        </ContentContainer>
      </TrackedLink>
    </CardLinkContainer>
  );
};
